<template>
	<div class="product-ootd">
		<h4 v-if="allOotdImgUrlAry[colorIndex].length > 0">{{ h4Title }}</h4>
		<slick
			ref="slick"
			:options="allOptions"
			:class="className"
			v-for="(node, index) in allOotdImgUrlAry"
			:key="node + index"
			v-show="index === colorIndex"
			@afterChange="handleAfterChange"
			@beforeChange="handleBeforeChange"
			@breakpoint="handleBreakpoint"
			@destroy="handleDestroy"
			@edge="handleEdge"
			@init="handleInit"
			@reInit="handleReInit"
			@setPosition="handleSetPosition"
			@swipe="handleSwipe"
			@lazyLoaded="handleLazyLoaded"
			@lazyLoadError="handleLazeLoadError"
		>
			<div v-for="(item, index) in node" :key="item + index">
				<a v-if="!/(blank)/.test(item)" href="javascript:;" @click="zoomImg(index, $event)">
					<i
						v-if="item.VideoUrl"
						class="icon-play d-md-inline-block d-none"
						style="
							position: absolute;
							top: 50%;
							left: 50%;
							margin-top: -20px;
							margin-left: -20px;
							background-size: 40px;
							z-index: 1;
						"
					></i>
					<i
						v-if="item.VideoMUrl"
						class="icon-play d-md-none d-inline-block"
						style="
							position: absolute;
							top: 50%;
							left: 50%;
							margin-top: -20px;
							margin-left: -20px;
							background-size: 40px;
							z-index: 1;
						"
					></i>
					<new-image :url="item.imgUrl" :size="picSize"></new-image>
				</a>
				<span v-else>
					<img :src="item" />
				</span>
			</div>
		</slick>
	</div>
</template>

<script>
import zoombox from "@global/components/product_vue/zoombox";
import NewImage from "@global/components/global/image";
import Slick from "@global/vendors/vue-slick";

export default {
	name: "Ootd",
	components: {
		Slick,
		NewImage,
	},
	props: {
		h4Title: {
			type: String,
			required: true,
		},
		ootdData: {
			type: Array,
			required: true,
		},
		allOotdData: {
			type: Array,
			required: true,
		},
		showQuantity: {
			type: Number,
			required: true,
		},
		sizeLogic: {
			type: String,
			required: true,
		},
		slick: {
			type: Boolean,
			required: true,
		},
		zbClass: {
			type: String,
			required: true,
		},
		FeaturedProducts: {
			type: Array,
		},
		title: {
			type: String,
		},
		slidesToShow: {
			type: Number,
		},
		arrows: {
			type: Boolean,
		},
		className: {
			type: String,
		},
		blankPicUrl: {
			type: String,
		},
		blankPicUrl: {
			type: String,
		},
		picSize: {
			type: String,
		},
	},
	data() {
		return {
			defaultOptions: {
				slidesToShow: 3,
				slidesToScroll: 3,
				dots: false,
				responsive: [
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						},
					},
				],
			},
			colorIndex: 0,
		};
	},
	computed: {
		ootdImgUrlArray() {
			let ootdImgUrlArray = [];
			for (var i = 0; i < this.ootdData.length; i++) {
				ootdImgUrlArray.push(this.ootdData[i]);
			}
			var remainder = this.ootdData.length % this.showQuantity; // 餘數
			if (remainder !== 0) {
				for (var b = 0; b < this.showQuantity - remainder; b++) {
					// 加入空白圖片方便輪播
					ootdImgUrlArray.push(this.blankPicUrl);
				}
			}
			return ootdImgUrlArray;
		},
		allOotdImgUrlAry() {
			let allOotdImgUrlAry = [];
			for (var i = 0; i < this.allOotdData.length; i++) {
				let ootdImgUrlArray = [];
				for (var j = 0; j < this.allOotdData[i].length; j++) {
					ootdImgUrlArray.push(this.allOotdData[i][j]);
				}
				var remainder = this.allOotdData[i].length % this.showQuantity; // 餘數
				if (remainder !== 0) {
					for (var b = 0; b < this.showQuantity - remainder; b++) {
						// 加入空白圖片方便輪播
						ootdImgUrlArray.push(this.blankPicUrl);
					}
				}
				allOotdImgUrlAry[i] = ootdImgUrlArray;
			}
			return allOotdImgUrlAry;
		},
		sizeLogicAry() {
			return this.sizeLogic.split("|");
		},
		allOptions() {
			let propsOption = {
				slidesToShow: this.slidesToShow,
				arrows: this.arrows,
				slidesToScroll: this.slidesToShow,
			};
			return $.extend({}, this.defaultOptions, propsOption);
		},
	},
	methods: {
		zoomImg(index, event) {
			const ootdData = this.allOotdImgUrlAry[this.colorIndex];
			const len = ootdData.length;
			let ootdArray = [];

			if (len !== 0) {
				for (let i = 0; i < len; i++) {
					let videoUrl = nowEnv.NowMyEquipment ? ootdData[i].VideoMUrl : ootdData[i].VideoUrl;
					ootdArray.push(videoUrl !== undefined && videoUrl.length !== 0 ? videoUrl : ootdData[i].imgUrl);
				}
			}
			zoombox({
				images: ootdArray,
				index: index,
				yPos: event.pageY - window.scrollY,
				tilting: false,
			});
		},
		next() {
			this.$refs.slick.next();
		},
		prev() {
			this.$refs.slick.prev();
		},
		reInit() {
			this.$nextTick(() => {
				this.$refs.slick.reSlick();
			});
		},
		handleAfterChange(event, slick, currentSlide) {},
		handleBeforeChange(event, slick, currentSlide, nextSlide) {},
		handleBreakpoint(event, slick, breakpoint) {},
		handleDestroy(event, slick) {},
		handleEdge(event, slick, direction) {},
		handleInit(event, slick) {},
		handleReInit(event, slick) {},
		handleSetPosition(event, slick) {},
		handleSwipe(event, slick, direction) {},
		handleLazyLoaded(event, slick, image, imageSource) {},
		handleLazeLoadError(event, slick, image, imageSource) {},
	},
};
</script>

<style></style>
